module.exports = __webpack_public_path__ + "static/media/boy.d7cbe5eb.jpg";